<template>
  <div
    :class="{ dragover: isDragging, 'show-error': showError }"
    @click="triggerFileDialog"
    @dragover.prevent="handleDragOver"
    @dragleave="handleDragLeave"
    @drop.prevent="handleDrop"
    class="upload-box"
    :style="styles"
  >
    <template v-if="loading">
      <!-- <v-spinner class="green upload-box-spinner" /> -->
      <v-progress-circular
        indeterminate
        color="primary"
      ></v-progress-circular>
      <div class="text-center">
        Файл загружается...
      </div>

    </template>
    <template v-else-if="isFileUploaded">
      <svg class="animated-check" viewBox="0 0 24 24">
        <path d="M4.1 12.7L9 17.6 20.3 6.3" fill="none" />
      </svg>
      {{ file.name }}
      <input ref="fileInput" @change="handleFileInput" type="file" style="display: none">
    </template>
    <template v-else>
      <!-- <v-icon class="upload-xls-icon">mdi-cloud-upload</v-icon> -->
      <svg class="upload-xls-icon" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M27.5 40V19.625L21 26.125L17.5 22.5L30 10L42.5 22.5L39 26.125L32.5 19.625V40H27.5ZM15 50C13.625 50 12.4479 49.5104 11.4688 48.5312C10.4896 47.5521 10 46.375 10 45V37.5H15V45H45V37.5H50V45C50 46.375 49.5104 47.5521 48.5312 48.5312C47.5521 49.5104 46.375 50 45 50H15Z" fill="#25325F"/>
      </svg>

      <p v-if="type !== 'service'">Перетащите файл или нажмите для выбора</p>
      <p class="upload-box__hint">Поддерживаемые форматы: <span v-for="(doc,idx) of acceptFile" :key="idx">{{doc}}, </span><br>Размер файла - не более 20 Мб</p>
      <input ref="fileInput" @change="handleFileInput" type="file" style="display: none">
    </template>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'UploadBox',
  components: {
  },
  props: {
    isFileUploaded: {
      type: Boolean ,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showError: {
      type: Boolean|| String,
      default: false,
    },
    acceptFile:{
      type: Array,
      default: ()=> ['DOCX', 'XLSX', 'PDF'],
    },
    type:{
      type: String,
      default: ()=>'',
    },
    styles:{
      type: Object,
      default: {},
    }

  },
  emits: ['upload'],
  data () {
    return {
      isDragging: false,
      file: ''
    }
  },
  computed: {
  },
  methods: {
    triggerFileDialog () {
      if (this.$refs.fileInput) {
        this.$refs.fileInput.click()
      }
    },
    handleDragOver () {
      this.isDragging = true
    },
    handleDragLeave () {
      this.isDragging = false
    },
    handleDrop (event) {
      this.isDragging = false
      const files = event.dataTransfer.files
      if (files.length) {
        this.processFiles(files)
      }
    },
    handleFileInput (event) {
      const files = event.target.files
      if (files.length) {
        this.processFiles(files)
      }
    },
    processFiles (files) {
      if (!this.loading && files && files.length > 0) {
        this.file = files[0]
        this.$emit('upload', files[0])
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/styles/variables";

.upload-box {
  width: 100%;
  height: 200px;
  border: 2px dashed #818181;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: white;
  color: #555;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-bottom: 20px;
  padding: 10px 20px;
}

.upload-box p {
  margin: 10px 0;
  font-weight: 400;
  font-size: 14px;
}

.upload-xls-icon{
  flex: 0 0 60px;
}

.upload-box:hover {
  background-color: #f7f7f7;
}

.upload-box.dragover {
  background-color: #e0f7ff;
  border-color: #0056b3;
}

.upload-box__hint {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 130%;
  color: #818181;
}

.upload-box.show-error {
  border-color:  var(--v-error-base);
  color:  var(--v-error-base);
}

.animated-check {
    height: 8em;
    width: 8em
}

.animated-check path {
    fill: none;
    stroke: #7ac142;
    stroke-width: 4;
    stroke-dasharray: 23;
    stroke-dashoffset: 23;
    animation: draw 0.5s linear forwards;
    stroke-linecap: round;
    stroke-linejoin: round
}

@keyframes draw {
    to {
        stroke-dashoffset: 0
    }
}

.upload-box-spinner {
  position: unset;
  margin-bottom: 10px;
}

</style>
